export default "__VITE_ASSET__Dy0pxygL__"